<template>
  <footer class="footer">
    <div class="networks-social">
      <a href="https://www.facebook.com/portaltransformacaodigital" target="_blank">Facebook</a>
      <a href="https://www.instagram.com/transformacao_digital" target="_blank">Instagram</a>
      <a href="https://www.linkedin.com/company-beta/22291584/" target="_blank">Linkedin</a>
      <a href="https://www.youtube.com/channel/UCk0lFSCTsTzZkK_dF5rXxYw" target="_blank">Youtube</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'v-footer',
};
</script>

<style lang="scss" scoped>
  .footer {
    .networks-social {
      display: flex;
      justify-content: center;
      @media (max-width: 576px) {
        flex-direction: column;
        padding: 24px 0;
      }
      a {
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 5px;
        text-indent: 5px;
        font-size: 14px;
        color: #d6d6d6;
        padding: 26px 52px;
        display: inline-block;
        text-decoration: none;
        transition: color .3s, background .3s;
        @media (max-width: 576px) {
          color: #121416;
        }
        &:hover {
          color: #121416;
          background-color: #f0f0f0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/vFooter.vue